import { FC } from 'react';
import styles from './CustomerUserItem.module.scss';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconError } from './img/iconError.svg';
import { UserType } from 'redux/Api/usersApi/type';
import { AppTooltip } from 'ui/AppTooltip';

interface CustomerUserItemTypes {
  user: UserType;
}

export const CustomerUserItem: FC<CustomerUserItemTypes> = ({ user }) => {
  const dateCreated = String(user.created_at).split('-').reverse().join('-');
  const dateUpdate = String(user.updated_at).split('-').reverse().join('-');

  const customers = user.customers;

  const tooltipChild =
    customers && customers.length > 1 ? (
      <sup className={styles.title_count}>+{customers.length - 1}</sup>
    ) : null;

  const otherCustomers = customers && customers.length > 1 ? customers.slice(1) : [];

  const tooltipContent = (
    <div>
      {otherCustomers.map((c) => (
        <div key={c.id} style={{ marginBottom: 8 }}>
          <div style={{ fontWeight: 500 }}>{c.jur_name}</div>
          <div style={{ fontSize: 13, color: '#7C8DA3' }}>
            ИНН {c.inn} &nbsp; КПП {c.kpp}
          </div>
          <div style={{ fontSize: 13, color: '#7C8DA3' }}>{c.position}</div>
        </div>
      ))}
    </div>
  );

  const formatPhone = (phone: string | null) =>
    phone
      ? `+${phone[0]} (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(
          7,
          9,
        )}-${phone.slice(9, 11)}`
      : '';

  return (
    <div className={styles.root}>
      <p className={styles.root_text}>
        <span>{user.id}</span>
      </p>
      <p className={styles.root_text}>
        <span>{user.surname}</span>
      </p>
      <p className={styles.root_text}>
        <span>{user.name}</span>
      </p>
      <p className={styles.root_text}>
        <span>{user.patronymic}</span>
      </p>
      <p className={styles.root_text}>
        <span>{user.role}</span>
      </p>
      <div className={styles.root_item}>
        <div
          className={styles.root_item__standart}
          style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
          <span className={styles.ellipsis}>
            {customers && customers.length > 0 && customers[0].jur_name}
          </span>
          <AppTooltip label={tooltipContent}>
            <span>{tooltipChild}</span>
          </AppTooltip>
        </div>
        {customers?.length ? (
          <div style={{ display: 'flex', columnGap: '10px' }}>
            <p className={styles.root_item__for_ndfl}>ИНН {customers?.[0]?.inn}</p>
            <p className={styles.root_item__for_ndfl}>КПП {customers?.[0]?.kpp}</p>
          </div>
        ) : null}
      </div>
      <p className={styles.root_text}>
        {user.is_promotional_emails_allowed === 0 ? <IconError /> : <IconDone />}
      </p>
      <p className={styles.root_text}>
        {user.is_terms_accepted === 0 ? <IconError /> : <IconDone />}
      </p>
      <p className={styles.root_text}>
        {user.is_order_notificiation_allowed ===
        null ? null : user.is_order_notificiation_allowed === 0 ? (
          <IconError />
        ) : (
          <IconDone />
        )}
      </p>
      <p className={styles.root_text}>{formatPhone(user.phone)}</p>
      <p className={styles.root_text}>{user.email}</p>
      <p className={styles.root_text}>{dateCreated}</p>
      <p className={styles.root_text}>{dateUpdate}</p>
      <p className={styles.root_text}>
        {user.is_2fa_enabled === 0 ? <IconError /> : <IconDone />}
      </p>
    </div>
  );
};
